import React from 'react';
import { TabbedShowLayout, Tab, TextField, UrlField, ReferenceManyField } from 'react-admin';

import Show from '../common/views/Show';
import DateField from '../common/fields/DateField';
import RichTextField from '../common/fields/RichTextField';
import ProjectRow from '../projects/ProjectList/ProjectRow';
import AddressRow from 'components/addresses/AddressRow';
import BudgetRow from 'components/budgets/BudgetRow';


const ProjectArrayField = (props) => (
	<ReferenceManyField {...props} reference="projects" target="customer_id">
		<ProjectRow />
	</ReferenceManyField>
);

const AddressesArrayField = (props) => (
	<ReferenceManyField {...props} reference="addresses" target="customer_id">
		<AddressRow />
	</ReferenceManyField>
);

const BudgetsArrayField = (props) => (
	<ReferenceManyField {...props} reference="budgets" target="customer_id">
		<BudgetRow />	
	</ReferenceManyField>
);

const CustomerShow = props => (
	<Show {...props}>
		<TabbedShowLayout>
			<Tab label="Summary">
				<TextField source="id" />
				<TextField source="name" />
				<TextField source="short_name" />
				<UrlField source="website" />
				<RichTextField source="description" />
				<DateField source="created_at" />
			</Tab>
			<Tab label="Projects">
				<ProjectArrayField label={false} />
			</Tab>
			<Tab label="Addresses">
				<AddressesArrayField label={false} />
			</Tab>
			<Tab label="Budgets">
				<BudgetsArrayField label={false} />	
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default CustomerShow;